module.exports = __webpack_public_path__ + "static/sheep1-0c3f5a9a3e8f29d37e0b13e2840890b2.jpeg";